import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Icon, Chip, Table, TableBody, TableRow, TableCell} from '@material-ui/core'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import {isEmpty} from 'lodash'
import { replaceDetteWithTaux } from 'src/shared/utils/helpers'
import { generateAdresseFormObj } from 'src/shared/utils/helpers'
import MailNotification from 'src/page/Consumer/MailNotification/MailNotification'

const styles = (t: Theme) => createStyles({
    expansionPnl: {
      boxShadow: 'none',
      '&:before': {
        display: 'none'
      },
    },
    title: {
      textTransform: 'uppercase'
    },
    typo: {
      padding: '4px 0'
    },
    info: {
      paddingLeft: '5px'
    },
    chip: {
        margin: `0 ${t.spacing.unit / 2}px`
    },
    xsScroll: {
      [t.breakpoints.down('sm')]: {
        overflow: 'auto'
      },
    },
    titleCell: {
      width: '400px',
      minWidth: '400px',
      maxWidth: '400px',
      [t.breakpoints.down('sm')]: {
        width: '300px',
        minWidth: '300px',
        maxWidth: '300px',
      },
    },
    invisibleForm: {
      height: 0,
      width: 0,
      overflow: 'hidden'
    },
    table: {    
      '& tbody tr td': {
          whiteSpace: 'normal'
    }
  }
});

interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  ReturnType<typeof state2props>{
}

class EnterpriseInfos extends React.Component<IProps, {}> {

  render(){
    const { t, classes, enterprise } = this.props;

    const INFOS_HABILITATION = [
      {label: t.EnterpriseDetail_info_general_habilitations_caption,  value: "habilitations",  type: "custom", formatter: (values) => this.renderHabilitations(values)},
      {label: t.EnterpriseDetail_info_general_mandataire,             value: "is_mandataire",  type: "chip"},
    ]
    const INFOS_GENERAL = [
      {label: t.EnterpriseDetail_info_general_denomination,     value: "name",                          type: "typography"},
      {label: t.address,                                        value: "address",                       type: "typography", restrict: (values) => !isEmpty(values), formatter: (values) => generateAdresseFormObj(values)},
      {label: t.EnterpriseDetail_info_general_delegation_emir,  value: "emir",                          type: "chip"},
      {label: t.EnterpriseDetail_info_general_lei,              value: "lei",                           type: "typography"},
      {label: t.EnterpriseDetail_info_general_max_operation,    value: "forex_operation_max_duration",  type: "typography", formatter: (values) => this.durationToLabel(values)},
      {label: t.EnterpriseDetail_info_general_rcs_city,         value: "rcs_city",                      type: "typography"},
      {label: t.EnterpriseDetail_info_general_siren,            value: "siren",                         type: "typography"},
      {label: t.EnterpriseDetail_info_web_conf,                 value: "web_conf",                      type: "chip"},
    ]

    return(
        <ExpansionPanel defaultExpanded={true} className={classes.expansionPnl}>
          <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
            <Typography variant="subtitle2" className={classes.title}>{t.EnterpriseDetail_info_general_title_first}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.xsScroll}>
            <div className="fullWidth">
              <MailNotification 
                activeLabel={t.user_notification_active_label}
                inactiveLabel={t.user_notification_inactive_label}
              />
              <br/>
              {enterprise &&
                <div style={{width: '100%'}}>
                  <Typography variant="subtitle2" className={classes.typo}>{t.EnterpriseDetail_info_general_habilitations_title}</Typography>
                  <br/>
                    {this.infosRender(enterprise, INFOS_HABILITATION)}
                  <br/><br/>
                  <Typography variant="subtitle2" className={classes.typo}>{t.EnterpriseDetail_info_general_title_second}</Typography>
                  <br/>
                    {this.infosRender(enterprise, INFOS_GENERAL)}
                </div>
              }
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
    )
  }

  @autobind
  private infosRender(enterprise, infos){
    const {classes} = this.props
    return (
      <Table>
        <TableBody>
          {infos.map(i => (
            <TableRow key={`info-row-${i.value}`}>
              <TableCell className={classes.titleCell}  key={`info-row-${i.value}--title`}>
                <Typography variant="body2" className={classes.typo}>{i.label}</Typography>
              </TableCell>
              <TableCell  key={`info-row-${i.value}--value`}>
                {this.infoRender(enterprise, i)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  @autobind
  private infoRender(enterprise, info){
    const {t, classes} = this.props
    const isExist = info.restrict ? info.restrict(enterprise[info.value]) : (enterprise[info.value] !== undefined && enterprise[info.value] !== null)
    return isExist ? (
      <>
        {info.type === "typography" &&
          <Typography variant="body2" className={classes.typo}>
            {info.formatter ? info.formatter(enterprise[info.value]) : enterprise[info.value]}
          </Typography>
        }
        {info.type === "chip" &&
          <Chip label={enterprise[info.value] ? t.yes : t.no} className={classes.chip} />
        }
        {info.type === "custom" &&
            <>
              {info.formatter ? info.formatter(enterprise[info.value]) : enterprise[info.value]}
            </>
        }
      </>
    ) : (
      <Typography variant="body2" className={classes.typo}>{t.not_available}</Typography>
    )
  }

  @autobind
  private durationToLabel(duration){
    const { t } = this.props;
    switch(duration){
      case 12:
        return `1 ${t.year_amount}`;
      case 18:
        return `18 ${t.months_amount}`;
      case 24:
      case 36:
      case 48:
      case 60:
      case 72:
        return `${duration / 12} ${t.years_amount}`;
      default:
        return "-";
    }
  }

  @autobind
  private renderHabilitations(habilitations){
    const { classes } = this.props;  
    if(habilitations){
        return habilitations.split(",").map((h: string, i: number) => {
            return <Chip 
                key={h}
                label={replaceDetteWithTaux(h.charAt(0).toUpperCase() + h.slice(1))}
                className={classes.chip}
            />
        })
    } else {
      return ""
    }
  }
}

const state2props = (state: RootState) => ({
  enterprise: state.accountInfo.enterpriseSelected,
});

export default compose(
  withI18n,
  connect(state2props),
  withStyles(styles)
)(EnterpriseInfos)



// WEBPACK FOOTER //
// ./src/page/Consumer/Enterprise/cards/EnterpriseInfos.tsx